export const initStickyHeader = () => {
    let header = document.getElementById('header');
    const checkScroll = () => {
        let shouldAddClass = header.classList.contains('sticky') && window.scrollY > 50;
        header.classList.toggle('scrolled', shouldAddClass);
    };

    window.addEventListener('scroll', checkScroll);
    checkScroll();
};
